import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import TextField from '@material-ui/core/TextField'
import {
	renameGroup,
	createGroup,
	handleGroupNameChange,
} from '../../actions/contacts/groups'
import language from 'utils/vast-languagepack'

const mapStateToProps = (state) => {
	return {
		groupNameFieldValue: state.contacts.renameGroupFieldValue,
	}
}

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			handleGroupNameChange,
			renameGroup,
			createGroup,
		},
		dispatch,
	)
}

class GroupName extends Component {
	componentWillUnmount() {
		this.props.handleGroupNameChange('')
	}

	handleChange = (e) => {
		clearTimeout(this.timeout)
		this.props.handleGroupNameChange(e?.target?.value)
		if (e?.target?.value) {
			this.setState({ typing: true })
			this.timeout = setTimeout(() => {
				if (this.props.groupID === 'new') {
					Promise.resolve(
						this.props.createGroup(this.props.groupNameFieldValue),
					).then(
						(payload) => {
							if (
								this.props.location.pathname.slice(0, 18) ===
								'/contactgroups/new'
							) {
								this.props.history.replace(`/contactgroups/${payload.id}`)
							}
						},
						(err) => {
							return
						},
					)
					this.setState({ typing: false })
				} else {
					this.props.renameGroup(
						this.props.groupID,
						this.props.groupNameFieldValue,
					)
					this.setState({ typing: false })
				}
			}, 500)
		}
	}

	render() {
		const { groupNameFieldValue, groupID } = this.props
		const error = !groupNameFieldValue?.length && groupID !== 'new'

		return (
			<TextField
				error={error}
				label={error ? 'Group name must have length' : 'Group name'}
				value={groupNameFieldValue}
				style={{ marginBottom: '10px', width: '100%' }}
				onChange={this.handleChange}
				placeholder={language.groups.placeholder.enterGroupName}
				// disabled
			/>
		)
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupName)
